<template lang="pug">
section
  div
    | The Home Office online form
    | is pretty straightforward to fill in,
    | and at the end of it you will be provided
    | with a list of documents
    | to be sent to the Home Office.
    | However, it would be awesome
    | if you could do it as easy,
    | issues might arise
    | while the Home Office reviews your application
    | and, in particular, the reasons
    | why your company wishes to become a sponsor,
    | correctness and completeness of information
    | and supporting documents provided by you.

  br

  div
    | 🚀
    |
    span(style="background: #ccedeb")
      | Nation.better will help you
      | to prepare an online form
      | to boost your chances of approval,
      | and we’ll use all data you provide
      | to us to populate your online form,
      | so you don’t have to do double work!

  br

  div
    b PAYE reference number

  div
    | Even it is not a ‘must’
    | during the application process
    | to have a Pay As You Earn (PAYE)
    | scheme reference number through
    | which the worker will be paid,
    | it is kind of obvious
    | you have to be registered
    | since you are requesting
    | to employ migrant workers,
    | and it takes minutes
    | to register on your HMRC account.
</template>

<script>
export default {
  name: "prepare_ao_oa",
};
</script>